import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...classes: ClassValue[]) => twMerge(clsx(classes));

export * from './buttonVariants';
export * from './deepMerge';
export * from './selectVariants';
export * from './tagVariants';
export * from './timePickerVariants';

export interface PackageRow {
    packageName: string;
    expireIn?: number;
}
export const getPackageName = (row: PackageRow, t: (key: string) => string) => {
    const expireIn = row.expireIn
        ? `/${row.expireIn}${row.expireIn === 1 ? t('general.day') : t('general.days')}`
        : '';
    return `${row.packageName}${expireIn}`;
};
